export const COLOURS_CHART = ["#9B59B6", "#F1C40F", "#F39C12", "#1ABC9C", "#3498DB"];
export const COLOURS_CHART_OTHERS = "#7F8C8D";

export const TOP_TRIGGERS_PER_TRIGGER = 10;
export const TOP_TRIGGERS_PER_DAY = 5;
